import * as React from 'react';
import { Button, List } from 'semantic-ui-react';
export var SubscriptionCard = function (_a) {
    var subscription = _a.subscription, onDelete = _a.onDelete;
    return (<List.Item verticalAlign='middle'>
		<List.Content data-testid='subscription'>
			<List divided horizontal>
				{subscription.tags.map(function (tag) { return (<List.Item key={tag.id}>{tag.title}</List.Item>); })}
			</List>
			<Button compact className='right floated' data-testid='delete-subscription' icon='delete' onClick={function () {
            onDelete(subscription.id);
        }}/>
		</List.Content>
	</List.Item>);
};
